import { Box, TableCell, TableCellProps } from "@mui/material";
import { ReactNode } from "react";

type TabPanelProps = { children?: ReactNode; value: number; index: number };

export function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

/** Header cell with the brand background used by every table of the user detail. */
export const HeadCell = (props: TableCellProps) => (
  <TableCell
    {...props}
    sx={{ backgroundColor: "#ba2156", color: "#fff", fontWeight: "bold" }}
  />
);
